import React, { useEffect, lazy, createElement } from 'react';
const WA_URL = 'https://wa.me/34604836989?text=Hola,%20quiero%20un%20presupuesto%20gratis%20para%20instalar%20suelo%20nuevo';
function WaIcon() {
  return <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" data-id="element-0">
      <path d="M17.47 14.38c-.3-.15-1.74-.86-2-.95-.27-.1-.46-.15-.66.15-.2.3-.76.95-.93 1.14-.17.2-.34.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.64-2.05-.17-.3-.02-.46.13-.61.13-.13.3-.34.45-.51.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.66-1.6-.9-2.18-.24-.57-.48-.5-.66-.5h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.2 5.08 4.49.71.3 1.26.49 1.69.63.71.22 1.36.19 1.87.12.57-.09 1.74-.71 1.99-1.4.24-.69.24-1.28.17-1.4-.07-.12-.27-.2-.57-.35zM12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38c1.45.79 3.08 1.21 4.79 1.21h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2z" data-id="element-1" />
    </svg>;
}
const LOGO_DARK = 'https://cdn.magicpatterns.com/uploads/bMU6QbKGb4YJatm2LUPygb/parquet72h_logo_horizontal_transparente.png';
const LOGO_LIGHT = 'https://cdn.magicpatterns.com/uploads/47E9fPA4oFUNYrtrw4cnDk/ELITE_UTILS_(16).png';
function Logo({
  variant = 'dark'
}: {
  variant?: 'dark' | 'light';
}) {
  return <a href="#" className="logo" aria-label="parquet72h" data-id="element-2">
      <img src={variant === 'light' ? LOGO_LIGHT : LOGO_DARK} alt="parquet72h" className="logo-img" data-id="element-3" />
    </a>;
}
export function App() {
  useEffect(() => {
    const SRC = 'https://elfsightcdn.com/platform.js';
    if (document.querySelector(`script[src="${SRC}"]`)) return;
    const s = document.createElement('script');
    s.src = SRC;
    s.async = true;
    document.head.appendChild(s);
  }, []);
  return <>
      <header className="site-header" data-id="element-4">
        <div className="wrap nav" data-id="element-5">
          <Logo data-id="element-6" />
        </div>
      </header>

      {/* HERO */}
      <section className="hero" data-id="element-7">
        <div className="hero-bg" data-id="element-8">
          <img src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=70" alt="Suelo de parquet recién instalado en un salón moderno" data-id="element-9" />
        </div>
        <div className="wrap hero-inner" data-id="element-10">
          <span className="badge-72 anim d1" data-id="element-11">
            <span className="dot" data-id="element-12"></span> Barcelona y alrededores
          </span>
          <h1 className="anim d2" data-id="element-13">
            Tu suelo nuevo instalado en <span className="hl" data-id="element-14">72 horas</span>
          </h1>
          <p className="sub anim d3" data-id="element-15">
            Tarima, parquet o vinílico colocado por profesionales. Sin semanas
            de obra, sin polvo, sin caos. Rápido, limpio y con garantía por
            escrito.
          </p>
          <div className="anim d4" data-id="element-16">
            <a className="btn-wa big" href={WA_URL} data-id="element-17">
              <WaIcon data-id="element-18" /> Pide tu presupuesto GRATIS
            </a>
            <p className="reassure" data-id="element-19">
              <b data-id="element-20">✓ Gratis y sin compromiso</b> · Respuesta en minutos por
              WhatsApp
            </p>
          </div>
        </div>
      </section>

      {/* TRUST STRIP */}
      <div className="strip" data-id="element-21">
        <div className="wrap" data-id="element-22">
          <span data-id="element-23">
            <svg fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" data-id="element-24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-25" />
            </svg>{' '}
            Instalación en 72h
          </span>
          <span data-id="element-26">
            <svg fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" data-id="element-27">
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-28" />
            </svg>{' '}
            Presupuesto gratis
          </span>
          <span data-id="element-29">
            <svg fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" data-id="element-30">
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-31" />
            </svg>{' '}
            Garantía por escrito
          </span>
          <span data-id="element-32">
            <svg fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" data-id="element-33">
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-34" />
            </svg>{' '}
            Instalación limpia
          </span>
        </div>
      </div>

      {/* PAIN / PROMISE */}
      <section className="pad" data-id="element-35">
        <div className="wrap" data-id="element-36">
          <div className="center" style={{
          maxWidth: 640
        }} data-id="element-37">
            <p className="eyebrow" data-id="element-38">Olvídate de las obras eternas</p>
            <h2 className="title" data-id="element-39">
              Cambiar el suelo no tiene por qué arruinarte el mes
            </h2>
            <p className="lead center" data-id="element-40">
              La mayoría imagina semanas de polvo, ruido y la casa patas arriba.
              Con parquet72h es otra historia.
            </p>
          </div>
          <div className="vs" data-id="element-41">
            <div className="vs-card bad" data-id="element-42">
              <h3 data-id="element-43">La reforma tradicional</h3>
              <ul className="vs-list" data-id="element-44">
                <li data-id="element-45">
                  <span className="ico" data-id="element-46">✕</span> Semanas con la casa inhabitable
                </li>
                <li data-id="element-47">
                  <span className="ico" data-id="element-48">✕</span> Polvo y escombros por todas
                  partes
                </li>
                <li data-id="element-49">
                  <span className="ico" data-id="element-50">✕</span> Fechas que se alargan sin fin
                </li>
                <li data-id="element-51">
                  <span className="ico" data-id="element-52">✕</span> Presupuestos que crecen sobre
                  la marcha
                </li>
              </ul>
            </div>
            <div className="vs-arrow" data-id="element-53">→</div>
            <div className="vs-card good" data-id="element-54">
              <h3 className="vs-card-title" data-id="element-55">
                <span data-id="element-56">Con</span>
                <Logo variant="light" data-id="element-57" />
              </h3>
              <ul className="vs-list" data-id="element-58">
                <li data-id="element-59">
                  <span className="ico" data-id="element-60">✓</span> Tu suelo nuevo listo en 72
                  horas
                </li>
                <li data-id="element-61">
                  <span className="ico" data-id="element-62">✓</span> Instalación limpia y ordenada
                </li>
                <li data-id="element-63">
                  <span className="ico" data-id="element-64">✓</span> Fecha cerrada que cumplimos
                </li>
                <li data-id="element-65">
                  <span className="ico" data-id="element-66">✓</span> Presupuesto claro y sin
                  sorpresas
                </li>
              </ul>
            </div>
          </div>
          <div className="center" style={{
          marginTop: 38
        }} data-id="element-67">
            <a className="btn-wa" href={WA_URL} data-id="element-68">
              <WaIcon data-id="element-69" /> Quiero mi suelo nuevo en 72h
            </a>
          </div>
        </div>
      </section>

      {/* CONOCE A MANUEL */}
      <section className="pad about" data-id="element-70">
        <div className="wrap" data-id="element-71">
          <div className="about-grid" data-id="element-72">
            <div className="about-photo" data-id="element-73">
              <img src="https://cdn.magicpatterns.com/uploads/nUiQwS81w4guHEPng7ZCLv/ChatGPT_Image_6_jun_2026,_17_03_28.png" alt="Manuel, fundador de parquet72h, instalando un suelo nuevo" data-id="element-74" />
            </div>
            <div className="about-text" data-id="element-75">
              <p className="eyebrow" data-id="element-76">Quién está detrás</p>
              <h2 className="title" data-id="element-77">Conoce a Manuel</h2>
              <p className="lead" data-id="element-78">
                El que estará en tu casa cuidando cada detalle como si fuera la
                suya.
              </p>
              <p className="about-p" data-id="element-79">
                Hola, soy Manuel, fundador de parquet72h. Llevo más de 20 años
                en el sector de las reformas en Barcelona y, después de ver
                demasiadas obras eternas y clientes desesperados, decidí montar
                algo diferente.
              </p>
              <p className="about-p" data-id="element-80">
                En parquet72h hacemos las cosas como me gustaría que las
                hicieran en mi propia casa: rápido, limpio y con la palabra dada
                por escrito. Si te digo que en 72 horas tienes tu suelo nuevo,
                en 72 horas lo tienes. Sin retrasos, sin sorpresas.
              </p>
              <p className="about-p" data-id="element-81"></p>
              <div className="about-stats" data-id="element-82">
                <div className="about-stat" data-id="element-83">
                  <span className="num" data-id="element-84">+20</span>
                  <span className="lbl" data-id="element-85">años en el oficio</span>
                </div>
                <div className="about-stat" data-id="element-86">
                  <span className="num" data-id="element-87">100%</span>
                  <span className="lbl" data-id="element-88">trabajos garantizados por escrito</span>
                </div>
                <div className="about-stat" data-id="element-89">
                  <span className="num" data-id="element-90">72h</span>
                  <span className="lbl" data-id="element-91">el plazo que cumplimos siempre</span>
                </div>
              </div>
              <a className="btn-wa" style={{
              marginTop: 30
            }} href="https://wa.me/34604836989?text=Hola%20Manuel,%20quiero%20un%20presupuesto%20gratis%20para%20instalar%20suelo%20nuevo" data-id="element-92">
                <WaIcon data-id="element-93" /> Habla directamente con Manuel
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* GALERIA */}
      <section className="pad" data-id="element-94">
        <div className="wrap" data-id="element-95">
          <div className="center" style={{
          maxWidth: 600
        }} data-id="element-96">
            <p className="eyebrow" data-id="element-97">Trabajos reales</p>
            <h2 className="title" data-id="element-98">Antes y después</h2>
            <p className="lead center" data-id="element-99">
              El cambio que un buen suelo puede dar a tu casa.
            </p>
          </div>
          <div className="gallery" data-id="element-100">
            <div className="ph" data-id="element-101">
              <span className="tag" data-id="element-102">Antes</span>
              <img src="https://images.unsplash.com/photo-1581622558663-b2e33377dfb2?auto=format&fit=crop&w=600&q=70" alt="Habitación antes" data-id="element-103" />
            </div>
            <div className="ph" data-id="element-104">
              <span className="tag" data-id="element-105">Después</span>
              <img src="https://images.unsplash.com/photo-1600210492493-0946911123ea?auto=format&fit=crop&w=600&q=70" alt="Habitación después" data-id="element-106" />
            </div>
            <div className="ph" data-id="element-107">
              <span className="tag" data-id="element-108">Antes</span>
              <img src="https://images.unsplash.com/photo-1567767292278-a4f21aa2d36e?auto=format&fit=crop&w=600&q=70" alt="Salón antes" data-id="element-109" />
            </div>
            <div className="ph" data-id="element-110">
              <span className="tag" data-id="element-111">Después</span>
              <img src="https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=600&q=70" alt="Salón después" data-id="element-112" />
            </div>
          </div>
        </div>
      </section>

      {/* QUE INSTALAMOS */}
      <section className="pad" style={{
      background: 'var(--cream-2)'
    }} data-id="element-113">
        <div className="wrap" data-id="element-114">
          <div className="center" style={{
          maxWidth: 620
        }} data-id="element-115">
            <p className="eyebrow" data-id="element-116">Todo tipo de suelo nuevo</p>
            <h2 className="title" data-id="element-117">Instalamos el suelo que quieres</h2>
            <p className="lead center" data-id="element-118">
              Sea cual sea tu estilo y tu presupuesto, tenemos la solución y la
              colocamos nosotros.
            </p>
          </div>
          <div className="grid3" data-id="element-119">
            <div className="floor-card" data-id="element-120">
              <img src="https://cdn.magicpatterns.com/uploads/dkdC8Mf1VMTN6R2MEJuq6A/tarima-flotante-malaga-foto1.jpg" alt="Tarima flotante" data-id="element-121" />
              <div className="cap" data-id="element-122">
                <h3 data-id="element-123">Tarima flotante</h3>
                <p data-id="element-124">Rápida, cálida y económica. Lista en un día.</p>
              </div>
            </div>
            <div className="floor-card" data-id="element-125">
              <img src="https://cdn.magicpatterns.com/uploads/kX39hkmbQ7SFyP4z4rHd5M/parquet-suelos-tarimas-1.jpg" alt="Parquet de madera" data-id="element-126" />
              <div className="cap" data-id="element-127">
                <h3 data-id="element-128">Parquet de madera</h3>
                <p data-id="element-129">Madera natural de primera. Elegancia que dura.</p>
              </div>
            </div>
            <div className="floor-card" data-id="element-130">
              <img src="https://cdn.magicpatterns.com/uploads/5aykXBxpRmusikW3xWR6EG/tipos-de-suelo-de-vinilo.jpg" alt="Suelo vinílico SPC" data-id="element-131" />
              <div className="cap" data-id="element-132">
                <h3 data-id="element-133">Vinílico / SPC</h3>
                <p data-id="element-134">Resistente al agua, perfecto para cocina y baño.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PASOS */}
      <section className="pad" data-id="element-135">
        <div className="wrap" data-id="element-136">
          <div className="center" style={{
          maxWidth: 600
        }} data-id="element-137">
            <p className="eyebrow" data-id="element-138">Así de fácil</p>
            <h2 className="title" data-id="element-139">Tu suelo nuevo en 3 pasos</h2>
          </div>
          <div className="steps" data-id="element-140">
            <div className="step" data-id="element-141">
              <span className="num" data-id="element-142"></span>
              <h3 data-id="element-143">Escríbenos por WhatsApp</h3>
              <p data-id="element-144">
                Cuéntanos qué necesitas y te damos presupuesto gratis, sin
                compromiso.
              </p>
            </div>
            <div className="step" data-id="element-145">
              <span className="num" data-id="element-146"></span>
              <h3 data-id="element-147">Visita y medición</h3>
              <p data-id="element-148">Vamos a tu casa, medimos y cerramos fecha y precio cerrado.</p>
            </div>
            <div className="step" data-id="element-149">
              <span className="num" data-id="element-150"></span>
              <h3 data-id="element-151">Instalamos en 72h</h3>
              <p data-id="element-152">
                Colocamos tu suelo nuevo de forma limpia y profesional. Listo
                para pisar.
              </p>
            </div>
          </div>
          <div className="center" style={{
          marginTop: 44
        }} data-id="element-153">
            <a className="btn-wa" href={WA_URL} data-id="element-154">
              <WaIcon data-id="element-155" /> Empezar ahora por WhatsApp
            </a>
          </div>
        </div>
      </section>

      {/* POR QUE */}
      <section className="pad why" data-id="element-156">
        <div className="wrap" data-id="element-157">
          <div className="center" style={{
          maxWidth: 620
        }} data-id="element-158">
            <p className="eyebrow" data-id="element-159">Por qué elegirnos</p>
            <h2 className="title" data-id="element-160">El suelo bien puesto, a la primera</h2>
          </div>
          <div className="feats" data-id="element-161">
            <div className="feat" data-id="element-162">
              <div className="fico" data-id="element-163">
                <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" data-id="element-164">
                  <circle cx="12" cy="12" r="9" data-id="element-165" />
                  <path strokeLinecap="round" d="M12 7v5l3 2" data-id="element-166" />
                </svg>
              </div>
              <div data-id="element-167">
                <h3 data-id="element-168">Instalación en 72 horas</h3>
                <p data-id="element-169">Cumplimos la fecha que te damos. Sin retrasos ni excusas.</p>
              </div>
            </div>
            <div className="feat" data-id="element-170">
              <div className="fico" data-id="element-171">
                <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" data-id="element-172">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14c-4 0-7 2-7 5v1h14v-1c0-3-3-5-7-5z" data-id="element-173" />
                </svg>
              </div>
              <div data-id="element-174">
                <h3 data-id="element-175">Equipo profesional</h3>
                <p data-id="element-176">
                  Instaladores con años de experiencia. Acabados impecables.
                </p>
              </div>
            </div>
            <div className="feat" data-id="element-177">
              <div className="fico" data-id="element-178">
                <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" data-id="element-179">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-180" />
                </svg>
              </div>
              <div data-id="element-181">
                <h3 data-id="element-182">Presupuesto gratis</h3>
                <p data-id="element-183">Sin compromiso y sin letra pequeña. Sabes lo que pagas.</p>
              </div>
            </div>
            <div className="feat" data-id="element-184">
              <div className="fico" data-id="element-185">
                <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" data-id="element-186">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-187" />
                </svg>
              </div>
              <div data-id="element-188">
                <h3 data-id="element-189">Instalación limpia</h3>
                <p data-id="element-190">Protegemos tu casa y recogemos todo al terminar.</p>
              </div>
            </div>
            <div className="feat" data-id="element-191">
              <div className="fico" data-id="element-192">
                <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" data-id="element-193">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.6-2.4A9 9 0 1112 3a9 9 0 019.6 6.6z" data-id="element-194" />
                </svg>
              </div>
              <div data-id="element-195">
                <h3 data-id="element-196">Garantía por escrito</h3>
                <p data-id="element-197">Te entregamos garantía firmada de la instalación.</p>
              </div>
            </div>
            <div className="feat" data-id="element-198">
              <div className="fico" data-id="element-199">
                <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" data-id="element-200">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 21s-7-5-7-11a7 7 0 0114 0c0 6-7 11-7 11z" data-id="element-201" />
                  <circle cx="12" cy="10" r="2.5" data-id="element-202" />
                </svg>
              </div>
              <div data-id="element-203">
                <h3 data-id="element-204">Barcelona y alrededores</h3>
                <p data-id="element-205">Damos servicio en toda la provincia. Cerca de ti.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIOS TEXTO */}
      <section className="pad" style={{
      background: '#ffffff'
    }} data-id="element-206">
        <div className="wrap" data-id="element-207">
          <div className="center" style={{
          maxWidth: 600
        }} data-id="element-208">
            <p className="eyebrow" data-id="element-209">Opiniones</p>
            <h2 className="title" data-id="element-210">Más de 200 hogares con suelo nuevo</h2>
          </div>
          <div className="elfsight-app-9fcb0efc-ebd1-4b2e-8331-535f6d6f5e68" data-elfsight-app-lazy style={{
          marginTop: 42
        }} data-id="element-211"></div>
        </div>
      </section>

      {/* OFERTA FINAL */}
      <section className="pad final" data-id="element-212">
        <div className="wrap" data-id="element-213">
          <span className="offer-tag" data-id="element-214">Presupuesto gratis sin compromiso</span>
          <h2 data-id="element-215">¿Listo para tu suelo nuevo en 72 horas?</h2>
          <p data-id="element-216">
            Escríbenos ahora por WhatsApp. Te respondemos en minutos y te damos
            precio sin compromiso.
          </p>
          <a className="btn-wa big" href={WA_URL} data-id="element-217">
            <WaIcon data-id="element-218" /> Pide tu presupuesto GRATIS
          </a>
          <p className="micro" data-id="element-219">Barcelona y alrededores · Respuesta inmediata</p>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="site-footer" data-id="element-220">
        <div className="wrap" data-id="element-221">
          <div className="foot-top" data-id="element-222">
            <div className="fcol" data-id="element-223">
              <Logo variant="light" data-id="element-224" />
              <p style={{
              maxWidth: 280,
              marginTop: 12
            }} data-id="element-225">
                Instalación de suelos nuevos en 72 horas. Rápido, limpio y con
                garantía.
              </p>
            </div>
            <div className="fcol" data-id="element-226">
              <h4 data-id="element-227">Servicios</h4>
              <p data-id="element-228">Tarima flotante</p>
              <p data-id="element-229">Parquet de madera</p>
              <p data-id="element-230">Suelo vinílico / SPC</p>
            </div>
            <div className="fcol" data-id="element-231">
              <h4 data-id="element-232">Contacto</h4>
              <p data-id="element-233">
                <a href={WA_URL} data-id="element-234">WhatsApp: +34 604 836 989</a>
              </p>
              <p data-id="element-235">Barcelona y alrededores</p>
              <p data-id="element-236">
                <a href="https://www.parquet72h.com" data-id="element-237">www.parquet72h.com</a>
              </p>
            </div>
          </div>
          <div className="foot-bot" data-id="element-238">
            © 2026 parquet72h.com · Todos los derechos reservados
          </div>
        </div>
      </footer>

      {/* STICKY MOBILE BAR */}
      <div className="sticky-bar" data-id="element-239">
        <a className="btn-wa" href={WA_URL} data-id="element-240">
          <WaIcon data-id="element-241" /> Presupuesto GRATIS por WhatsApp
        </a>
      </div>

      {/* FLOATING DESKTOP WA */}
      <a className="float-wa" href={WA_URL} aria-label="WhatsApp" data-id="element-242">
        <WaIcon data-id="element-243" />
      </a>
    </>;
}